// ============================================
// App.js — Root component with loading screen
//          and persistent 3D background
// ============================================
import React, { useState } from 'react';
import Loader       from './components/Loader';
import Background3D from './components/Background3D';
import Navbar       from './components/Navbar';
import Hero         from './components/Hero';
import About        from './components/About';
import Certificates from './components/Certificates';
import Projects     from './components/Projects';
import Contact      from './components/Contact';
import Footer       from './components/Footer';
import CustomCursor from './components/CustomCursor';
import './styles/scrollReveal.css';

function App() {
  const [loaded, setLoaded] = useState(false);

  return (
    <>
      {/* Cinematic loading screen */}
      {!loaded && <Loader onComplete={() => setLoaded(true)} />}

      {/* Persistent 3D wireframe background — reacts to mouse */}
      <Background3D />

      {/* Custom animated cursor */}
      <CustomCursor />

      {/* Site content fades in after loader */}
      <div className={`site-wrapper ${loaded ? 'site-visible' : ''}`}>
        <Navbar />
        <main>
          <Hero />
          <About />
          <Certificates />
          <Projects />
          <Contact />
        </main>
        <Footer />
      </div>
    </>
  );
}

export default App;
